module.exports = __webpack_public_path__ + "img/cz-feature.0ff5b8aa.jpg";